import React, {useEffect, useState} from "react";
import {getToken} from "../../utils/common";
import {Login} from "../login";
import Dashboard from "../dashboard";
import history from "../../history"
import {Config, MessengerConfigOptions} from "../../@types/config";
import agent from "../../agent";
import {Loader} from "semantic-ui-react";

export function Auth(): JSX.Element {
    const [authenticated, setAuthenticated] = useState<boolean | undefined>(undefined);
    const [configLoaded, setConfigLoaded] = useState<boolean>(false);

    useEffect(() => {
        const loadConfig = async () => {
            const messengersConfig: MessengerConfigOptions = await agent.ConfigProvider.messengers();
            window.config = {...window.config, ...messengersConfig} as Config;
            setConfigLoaded(true);
        }

        if (getToken()) {
            loadConfig().catch(console.error);
            setAuthenticated(true);
        } else {
            history.push('/')
        }
    }, []);

    if (authenticated === undefined) {
        return <></>
    } else if (authenticated) {
        return (configLoaded ? <Dashboard history={history}/> : <Loader active />)
    } else {
        return (
            <Login/>
        )
    }
}
